import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
import { usePantoneColorsCheckQuery } from './__generated__/usePantoneColorsCheckQuery.graphql';

export const usePantoneColorsCheck = () => {
    const query = useLazyLoadQuery<usePantoneColorsCheckQuery>(
        graphql`
            query usePantoneColorsCheckQuery {
                hasPantoneColors
            }
        `,
        {},
        { fetchPolicy: 'network-only' }
    );

    return { data: query, hasPantoneColors: query?.hasPantoneColors ?? false };
};
